module.exports = {
  ALERT_TIMEOUT: 6000,
  MESSAGE_TIMEOUT: 5000,

  backendHOST: process.env.REACT_APP_BACKEND_HOST
    ? process.env.REACT_APP_BACKEND_HOST
    : '', // prod
  backendHOST_TaeBack: process.env.REACT_APP_BACKEND_HOST2
    ? process.env.REACT_APP_BACKEND_HOST2
    : '', //'https://tanyaeback.azurewebsites.net', // prod
  LANG: 'HU',
  log_on: 1, //1- only errors 5- full
  axios_header: {
    headers: {
      'Content-Type': 'application/json',
      'x-auth-token': localStorage.token,
    },
  },
};
